import { jwtDecode } from 'jwt-decode';
import { ServiceCookies } from '@services/ServiceCookies';
import { jwtPayload } from '@app/Types/Jwt';

export const checkedValidateToken = (): boolean => {
  try {
    if (!ServiceCookies.jwtAccess) {
      throw new Error('нет токена');
    }

    const payload = jwtDecode<jwtPayload>(ServiceCookies.jwtAccess);
    const time = parseInt((new Date().getTime() / 1000).toString());

    if (!payload.phone) {
      return false;
    }

    return payload.exp > time;
  } catch (error) {
    console.log('error checkedValidateToken: ', error.message);
    return false;
  }
};
